export default "__VITE_ASSET__ecgz0ZuI__"